const AllFeedback = () => import("./views/AllFeedback.vue");
const FeedbackFormCreate = () => import("./views/FeedbackFormCreate.vue");
const AllFeedbackLogs = () => import("./views/AllFeedbackLogs.vue");

export default [
  {
    path: "view-all",
    component: AllFeedback,
  },
  {
    path: "create",
    component: FeedbackFormCreate,
  },
  {
    path: "view-feedback-log",
    component: AllFeedbackLogs,
  },
];
